
namespace GeniuzPOS.SalePromoCamp {

    export interface EnumFlagsEditorOptions {
        enumKey?: string;
    }

    /**
     * This is an editor widget for Enum Flags
     */
    @Serenity.Decorators.registerEditor('GeniuzPOS.SalePromoCamp.PromoDayFgEditor', [Serenity.IDoubleValue, Serenity.IReadOnly])
    @Serenity.Decorators.element('<div/>')
    export class PromoDayFgEditor extends Serenity.Widget<EnumFlagsEditorOptions>
        implements Serenity.IReadOnly {

        private flagValues: number[] = [];
        constructor(input: JQuery, opt: EnumFlagsEditorOptions) {
            super(input, opt);

            if (Q.isEmptyOrNull(this.options.enumKey))
                return;
           
            var enumType = Serenity.EnumTypeRegistry.get(this.options.enumKey);
            var enumKey = this.options.enumKey;
            if (enumKey == null && enumType != null) {
                var enumKeyAttr = Q.getAttributes(enumType, Serenity.EnumKeyAttribute, false);
                if (enumKeyAttr.length > 0)
                    enumKey = enumKeyAttr[0].value;
            }

            var values = Q.Enum.getValues(enumType);
            for (var x of values) {
                this.flagValues.push(Q.toId(x));
                var name = Q.Enum.toString(enumType, x);
                this.addCheckBox(x.toString(), Q.tryGetText(
                    'Enums.' + enumKey + '.' + name) ?? name);
            }

            this.flagValues.sort((prev, next) => next - prev);
        }

        protected addCheckBox(value: string, text: string) {
            var label = $('<label />').text(text);
            $('<input type="checkbox" />')
                .attr('id', this.uniqueName + '_' + value)
                .attr('value', value).prependTo(label);
            label.appendTo(this.element);
        }

        get_value(): number {
            var checks = this.element.find('input:checked');
            var sum = 0;

            for (var idx = 0; idx < checks.length; idx++)
                sum += Q.toId((checks[idx] as HTMLInputElement).value);

            return sum;
        }

        get value(): number {
            return this.get_value();
        }

        set_value(value: number): void {
            if (value !== this.get_value()) {
                var inputs = this.element.find('input');
                var checks = inputs.filter(':checked');

                for (var idx = 0; idx < checks.length; idx++)
                    (checks[idx] as HTMLInputElement).checked = false;

                if (!value)
                    return;

                var flags = this.parseFlags(value);
                for (var val of flags) {
                    checks = inputs.filter('[value=' + val + ']');
                    if (checks.length > 0) {
                        (checks[0] as HTMLInputElement).checked = true;
                    }
                }
            }
        }

        set value(v: number) {
            this.set_value(v);
        }

        get_readOnly(): boolean {
            return this.element.attr('disabled') != null;
        }

        set_readOnly(value: boolean): void {
            if (this.get_readOnly() !== value) {
                if (value) {
                    this.element.attr('disabled', 'disabled')
                        .find('input').attr('disabled', 'disabled');
                }
                else {
                    this.element.removeAttr('disabled')
                        .find('input').removeAttr('disabled');
                }
            }
        }

        private parseFlags(flagValue: number): number[] {
            var parsedValues: number[] = [];

            for (var val of this.flagValues) {
                if (flagValue >= val) {
                    parsedValues.push(val);
                    flagValue -= val;
                }
            }

            return parsedValues;
        }
    }
}